<template>
  <div v-if="isVisible" class="slider-cart">
    <div class="slider-cart-header">
      <h3>{{ $t("footer.shoppingCart") }} ({{ cartData.length }})</h3>
      <button class="close-btn" @click="toggleCart">&times;</button>
    </div>
    <div class="slider-cart-content" v-if="cartData.length > 0">
      <div v-for="item in cartData" :key="item.id" class="cart-item">
        <img :src="item.images.icon" alt="Product Image" class="item-image" />
        <div class="item-details">
          <h4>{{ item.Name }}</h4>
          <p>{{ item.Quantity }} x {{ item.price }}</p>
        </div>
        <button
          class="remove-btn"
          @click="removeItemFromCart(item)"
          v-if="item._id != '67f0bd1458eeb6f746342b34'"
        >
          &times;
        </button>
      </div>
      <div class="cart-footer">
        <div class="cart-summary">
          <p>{{ cartData.length }} {{ $t("product") }}(s)</p>
          <p class="total-price">${{ totalPrice }}</p>
        </div>
        <div class="cart-actions">
          <button
            @click="handleActionAndCloseCart('/checkout')"
            class="btn btn-primary"
          >
            {{ $t("checkout.checkout") }}
          </button>
          <router-link
            :to="{ name: 'checkout' }"
            class="btn btn-secondary"
            @click.native="handleActionAndCloseCart('/checkout')"
          >
            {{ $t("checkout.gotocart") }}
          </router-link>
        </div>
      </div>
    </div>

    <!-- Empty Cart Message -->
    <div v-else class="cart-empty">
      <p>{{ $t("checkout.yourcartisempty") }}!</p>
      <button @click="handleActionAndCloseCart('/')" class="btn btn-secondary">
        {{ $t("checkout.shopnow") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    cartItem: {
      default: () => {},
      type: Object,
    },
    callCheckout: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      cartData: (state) => state.checkout.cartData,
      isLoading: (state) => state.checkout.isLoading,
      totalPrice: (state) => state.checkout.checkoutData.totalPrice,
    }),
  },
  methods: {
    ...mapActions("checkout", ["clearCart", "fetchCartData"]),
    toggleCart() {
      this.$emit("toggle-cart");
    },
    proceedToCheckout() {
      this.$router.push("/checkout");
      this.toggleCart();
    },
    async removeItemFromCart(item) {
      await this.$store.dispatch("checkout/removeItem", {
        cartItem: item,
        callApi: true,
      });
      await this.$store.dispatch("checkout/checkoutFinal");
    },
    handleActionAndCloseCart(route) {
      this.$router.push(route);
      this.toggleCart();
    },
  },
  mounted() {
    // this.$store.state["checkout"].paymentMethodClick = "COD";
    // this.fetchCartData();
  },
};
</script>

<style scoped>
.slider-cart {
  position: fixed;
  top: 0;
  right: 0;
  width: 350px;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 999;
  overflow-y: auto;
  font-family: Arial, sans-serif;
}
.slider-cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  color: black !important;
}
.slider-cart-header h3 {
  margin: 0;
  font-size: 18px;
}
.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
.slider-cart-content {
  padding: 15px;
}
.cart-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.item-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 10px;
}
.item-details {
  text-align: left !important;
  flex: 1 !important;
  color: #000 !important;
}
.item-details h4 {
  margin: 0 0 5px !important;
  font-size: 16px !important;
}
.item-details p {
  margin: 0 !important;
  font-size: 14px !important;
  color: #555 !important;
}
.remove-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #ff0000;
}
.cart-footer {
  border-top: 1px solid #eee;
  padding-top: 15px;
  margin-top: 15px;
}
.cart-summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  color: black !important;
}
.total-price {
  font-weight: bold;
  font-size: 18px;
}
.cart-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.btn {
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
.btn-primary {
  background: #ff6f00;
  color: #fff;
}
.btn-secondary {
  background: #f2f2f2;
  color: #555;
}
.cart-empty {
  text-align: center;
  padding: 20px;
}
.cart-empty p {
  margin: 0 0 10px;
  color: #000;
  font-size: 16px;
}
</style>
